"use client";
import styled from "styled-components";
import {Col, Container, Row} from "react-bootstrap";
import Select, {components} from "react-select";
import React, {useEffect, useState} from "react";
import {hover} from "@/styles/globalStyleVars";
import DownloadSingle from "@/components/media/DownloadSingle";
import {usePathname} from "next/navigation";
import {getApiHUB} from "@/api";

const MediaListing = ({ data }) => {
  const pathname = usePathname();
  const [offset, setOffset] = useState(115);
  const [dataAll, setDataAll] = useState(data);
  const [dataAllGFilter, setDataAllFilter] = useState(data);
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeIndexSlug, setActiveIndexSlug] = useState(0);
  useEffect(() => {
    const handleResize = () => {
      setOffset(document.querySelector(".container").offsetLeft);
    };

    window.addEventListener("load", handleResize);
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("load", handleResize);
      window.removeEventListener("resize", handleResize);
    };
  }, [pathname]);
  const customStyles = {
    dropdownIndicator: (base, state) => ({
      ...base,
      transition: "all .2s ease",
      // transform: state.selectProps.menuIsOpen && "rotate(180deg)"
    }),
    option: (provided, state) => ({
      ...provided,
      borderRadius: 0,
      color: state.isSelected ? `${hover}` : "#221F1F",
      backgroundColor: state.isSelected ? `rgba(232, 231, 231, 0.6)` : "#FFF",
      margin: 0,
      fontSize: 14,
      cursor: "pointer",
      paddingLeft: 10,
      paddingRight: 10,
      fontWeight: state.isSelected ? 600 : 400,
      "&:hover": {
        backgroundColor: `rgba(232, 231, 231, 0.8)`,
        color: "#FFF",
        cursor: "pointer",
      },
    }),
    menu: (provided, state) => ({
      ...provided,
      color: "#FFF",
      backgroundColor: state.isSelected ? `${hover}` : "rgba(255,255,255,0)",
      margin: 0,
      borderRadius: 0,
      fontSize: 14,
      zIndex: 10,
      // width: 200,
    }),
    menuList: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? `${hover}` : "#FFF",
      borderRadius: 0,
      fontWeight: "400",
      color: "#FFF",
      // fontSize: 14,
    }),
  };

  const options = [{ value: "all", label: "All" }];

  const CaretDownIcon = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13.414"
        height="7.414"
        viewBox="0 0 13.414 7.414"
      >
        <g
          id="Group_15659"
          data-name="Group 15659"
          transform="translate(1479.207 -192.793) rotate(90)"
        >
          <line
            id="Line_3883"
            data-name="Line 3883"
            x2="6"
            y2="6"
            transform="translate(193.5 1466.5)"
            fill="none"
            stroke="#FFFFFF"
            strokeLinecap="round"
            strokeWidth="1"
          />
          <line
            id="Line_3884"
            data-name="Line 3884"
            y1="6"
            x2="6"
            transform="translate(193.5 1472.5)"
            fill="none"
            stroke="#FFFFFF"
            strokeLinecap="round"
            strokeWidth="1"
          />
        </g>
      </svg>
    );
  };
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <CaretDownIcon />
      </components.DropdownIndicator>
    );
  };

  const mergedOptions = options.concat(
    data?.filter?.map((item) => ({
      value: item.value,
      label: item.label,
    }))
  );

  const handleClick = async (param, category, index) => {
    try {
      const getHomeData = await getApiHUB(param, category);
      const newBanner = getHomeData?.[0];
      setDataAll(newBanner);
      setDataAllFilter(newBanner);
      setActiveIndex(index, "index");
      setActiveIndexSlug(param)


    } catch (error) {
      console.error("Error fetching data:", error);
      setDataAll(data);
    }
  };

  const handleSelect = async (param, category, index) => {
    try {
      const getHomeData = await getApiHUB(param, index?.label);
      const newBanner = getHomeData?.[0];
      setDataAll(newBanner);
      setDataAll(newBanner);
      setActiveIndex(index, "index");
    } catch (error) {
      console.error("Error fetching data:", error);
      setDataAll(data);
    }
  };


  return (
    <StyledMediaListing className="media-listing pb-200" offset={offset}>
      <Container fluid>
        <Row className={"media-listing__filter"}>
          <Col>
            <div className="media-listing__filter__desktop">
              <ul className={"media-cat-list"}>
                <li key={0}>
                  <a
                    href="javascript:void(0)"
                    className={0 === activeIndex ? "active" : ""}
                    onClick={() => handleClick("download-hub", "", 0)}
                  >
                    All
                  </a>
                </li>
                {data?.filter &&
                  data?.filter?.length > 0 &&
                  data?.filter?.map((e, index) => {
                    return (
                      <li key={index + 1}>
                        <a
                          href="javascript:void(0)"
                          className={index + 1 === activeIndex ? "active" : ""}
                          onClick={() =>
                            handleClick("download-hub", e?.value, index + 1)
                          }
                        >
                          {e?.label}
                        </a>
                      </li>
                    );
                  })}
              </ul>
            </div>

            <div className="media-listing__filter__mobile">
              <Select
                classNamePrefix="filter"
                onChange={(e) =>
                  handleSelect("download-hub", mergedOptions?.[0]?.value, e)
                }
                isSearchable={false}
                styles={customStyles}
                components={{ DropdownIndicator }}
                options={mergedOptions}
                placeholder={"All"}
                defaultValue={mergedOptions?.[0]?.value}
              />
            </div>
          </Col>
        </Row>

        <Row className={"download-list"}>
          {


              dataAll?.list &&
              dataAll?.list?.length > 0 &&
              dataAll?.list?.map((e, index) => {
                  return (
                      <Col key={index} md={4}>
                        <DownloadSingle
                            date={e?.date}
                            link={e?.file}
                            title={e?.post_title}
                            category={e?.media_cat}
                        />
                      </Col>
                  );
                })


          }


        </Row>
      </Container>
    </StyledMediaListing>
  );
};

const StyledMediaListing = styled.section`
  padding-top: 60px;
  padding-right: ${(p) => p.offset + "px"};
  background-color: #f4f4f4;

  .media-listing__filter {
    .media-cat-list {
      display: flex;
      border-bottom: 1px solid #191919;

      li {
        a {
          display: block;
          padding: 15px 30px;
          width: 100%;
          height: 100%;
          font-size: 16px;
          line-height: 20px;
          color: #191919;

          &.active {
            color: #fff;
            background: #191919;
          }
        }
        &:not(:last-child) {
          border-right: 1px solid #191919;
        }
      }
    }
  }

  .css-13cymwt-control {
    border-radius: 0px !important;
    border-bottom: 1px solid rgba(25, 25, 25, 0.2) !important;
    border: none;
    &:hover {
      border-bottom: 1px solid rgba(25, 25, 25, 0.2) !important;
    }
  }

  .css-1u9des2-indicatorSeparator {
    background-color: transparent;
  }

  .css-1dimb5e-singleValue {
    font-size: 20px;
    line-height: 28px;
    font-weight: 700;
    color: #191919 !important;
    padding-top: 10px;
  }

  .css-1jqq78o-placeholder {
    font-size: 20px;
    line-height: 28px;
    font-weight: 700;
    padding-top: 10px;
    color: #191919 !important;
    padding-left: 0px !important;
  }

  .css-yk16xz-control .css-1wa3eu0-placeholder,
  .css-1pahdxg-control .css-1wa3eu0-placeholder,
  .css-1uccc91-singleValue {
    color: #3c4348 !important;
    font-size: 14px !important;
    font-weight: bold;
    cursor: pointer;
    letter-spacing: 2px !important;
    text-transform: capitalize !important;
  }

  .filter__single-value.css-1dimb5e-singleValue {
    text-transform: capitalize;
    padding-left: 0px !important;
  }

  .css-1s4cg4l-indicatorContainer {
    font-size: 17px;
    line-height: 24px;
    font-weight: 700;
    color: White !important;
    margin-right: 5px !important;
  }

  .filter__control {
    border-radius: 0 !important;
    background-color: transparent !important;
    height: 60px;

    &--menu-is-open {
      border-radius: 0 !important;
      background-color: transparent !important;
      border: none;
    }
  }

  .filter__dropdown-indicator {
    margin-right: 5px !important;
    background-color: black;
  }

  .media-listing__filter__desktop {
    @media (max-width: 767px) {
      display: none;
    }
  }
  .media-listing__filter__mobile {
    display: none;
    @media (max-width: 767px) {
      display: block;
    }
  }

  @media (max-width: 767px) {
    margin-top: 0;
    padding-left: 0;
  }
  .css-t3ipsp-control {
    box-shadow: none !important;
    border-color: unset !important;
    border: none !important;
    border-bottom: 1px solid rgba(25, 25, 25, 0.2) !important;
  }

  @media (max-width: 767px) {
    padding-top: 40px;
  }

  .css-1fdsijx-ValueContainer {
    padding-left: 0;
  }

  .download-list {
    margin-top: 60px;
    display: flex;
    .col-md-4 {
      margin-bottom: 30px;
    }
  }

  @media (max-width: 767px) {
    padding-left: 15px;
    padding-right: 15px;
  }
`;
export default MediaListing;
